import React, { useEffect, useState } from "react"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import { useGetConfigMutation } from "../../../api/services"
import "../assets/style.scss"
import Block from "@bappweb/block"

const SssList = (props) => {

  const [faqText, setFaqText] = useState<any[]>([]);
  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("WebKonut.Landing.Faq")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setFaqText(JSON.parse(payload.configValue))
        }
      })
  }, [getConfig])

  return (
    <Page padding={false}>
      <Panel hasFooter={false} noHeader id={props.id} className="ssslist">
      <Element type="h2">Bilmem gereken başka neler var?</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          className=""
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item:any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              ><Block dangerouslySetInnerHTML={{ __html: item?.data }} /></List.Item>
            )
          })}
        </List>
      </Panel>
    </Page>
  )
}

export default SssList
